import React from 'react';
import Logo from "../utilities/Logo";
import {Box, Flex} from "@chakra-ui/layout";
import {Button, Link, Menu, MenuButton, MenuItem, MenuList} from "@chakra-ui/react";
import {NavLink} from "react-router-dom";

function Header() {
  return (
    <Flex justifyContent={"space-between"} py={6} px={{base: 2, md: 6}}>
      <Logo _fontSize={"lg"} _mt={0}/>
      <Flex>
        <Menu >
          <MenuButton as={Button} bgColor={"white"} borderRadius={"26px"} mr={2} fontSize={"md"}>
            Login <i className={"fas fa-chevron-down"}/>
          </MenuButton>
          <MenuList>
            <MenuItem>
              <Link as={NavLink} to={"/auth/student/login"} display={"block"}>Student</Link>
            </MenuItem>
            <MenuItem>
              <Link as={NavLink} to={"/auth/tutor/login"} display={"block"}>Tutor</Link>
            </MenuItem>
          </MenuList>
        </Menu>
        <Menu>
          <MenuButton as={Button} bgColor={"brand.gold"} color={"brand.white"} borderRadius={"26px"}>
            Sign Up <i className={"fas fa-chevron-down"}/>
          </MenuButton>
          <MenuList>
            <MenuItem>
              <Link as={NavLink} to={"/auth/student/signup"} display={"block"}>Student</Link>
            </MenuItem>
            <MenuItem>
              <Link as={NavLink} to={"/auth/tutor/signup"} display={"block"}>Tutor</Link>
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
}

export default Header;